import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: 150px;\n  height: 64px;\n\n  & :hover {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { vars } from "@pancakeswap/ui/css/vars.css";
import React from "react";
import styled from "styled-components";
import { Image, Link as UIKitLink } from "@pancakeswap/uikit";
import { Box, Flex } from "../Box";
import { Link } from "../Link";
import { StyledFooter, StyledIconMobileContainer, StyledList, StyledListItem, StyledSocialLinks, StyledText, StyledToolsContainer } from "./styles";
import { Button } from "../Button";
import CakePrice from "../CakePrice/CakePrice";
import { ArrowForwardIcon, LogoWithTextIcon, LogoIcon } from "../Svg";
var StyledKYCLink = styled(UIKitLink).withConfig({
    componentId: "sc-5690432e-0"
})(_templateObject());
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    return /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
        "data-theme": "dark",
        p: [
            "40px 16px",
            null,
            "56px 40px 32px 40px"
        ]
    }, props), {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: "column",
            width: [
                "100%",
                null,
                "1200px;"
            ],
            children: [
                /*#__PURE__*/ _jsx(StyledIconMobileContainer, {
                    display: [
                        "block",
                        null,
                        "none"
                    ],
                    children: /*#__PURE__*/ _jsx(LogoIcon, {
                        width: "80px"
                    })
                }),
                /*#__PURE__*/ _jsxs(Flex, {
                    order: [
                        2,
                        null,
                        1
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: [
                        "42px",
                        null,
                        "36px"
                    ],
                    children: [
                        /*#__PURE__*/ _jsx(StyledKYCLink, {
                            href: "https://assuredefi.com/projects/chewyswap/",
                            target: "_blank",
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: "/images/kyc.png",
                                alt: "View ChewySwap KYC Certificate",
                                width: 150,
                                height: 64
                            })
                        }),
                        items === null || items === void 0 ? void 0 : items.map(function(item) {
                            var ref;
                            /*#__PURE__*/ return _jsxs(StyledList, {
                                children: [
                                    /*#__PURE__*/ _jsx(StyledListItem, {
                                        children: item.label
                                    }),
                                    (ref = item.items) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                        var label = param.label, href = param.href, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted;
                                        return /*#__PURE__*/ _jsx(StyledListItem, {
                                            children: href ? /*#__PURE__*/ _jsx(Link, {
                                                "data-theme": "dark",
                                                href: href,
                                                target: "_blank",
                                                rel: "noreferrer noopener",
                                                color: isHighlighted ? vars.colors.warning : "text",
                                                bold: false,
                                                children: label
                                            }) : /*#__PURE__*/ _jsx(StyledText, {
                                                children: label
                                            })
                                        }, label);
                                    })
                                ]
                            }, item.label);
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            display: [
                                "none",
                                null,
                                "block"
                            ],
                            children: /*#__PURE__*/ _jsx(LogoWithTextIcon, {
                                isDark: true,
                                width: "160px"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(StyledSocialLinks, {
                    order: [
                        2
                    ],
                    pb: [
                        "42px",
                        null,
                        "32px"
                    ],
                    mb: [
                        "0",
                        null,
                        "32px"
                    ]
                }),
                /*#__PURE__*/ _jsxs(StyledToolsContainer, {
                    "data-theme": "dark",
                    order: [
                        1,
                        null,
                        3
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ _jsx(Flex, {
                            order: [
                                2,
                                null,
                                1
                            ],
                            alignItems: "center"
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            order: [
                                1,
                                null,
                                2
                            ],
                            mb: [
                                "24px",
                                null,
                                "0"
                            ],
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    mr: "20px",
                                    children: /*#__PURE__*/ _jsx(CakePrice, {
                                        cakePriceUsd: cakePriceUsd,
                                        color: "textSubtle"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    "data-theme": "light",
                                    as: "a",
                                    href: "https://chewyswap.dog/#/swap?outputCurrency=0x2761723006d3eb0d90b19b75654dbe543dcd974f",
                                    scale: "sm",
                                    endIcon: /*#__PURE__*/ _jsx(ArrowForwardIcon, {
                                        color: "white"
                                    }),
                                    children: buyCakeLabel
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
export default MenuItem;
